import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Freizeit.css';
import BackArrow from '../../BackArrow';

function Freizeit() {
  const navigate = useNavigate();

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  const bereich = getCookie('Bereich');
  const bereichClass = bereich ? bereich.replace(/[^a-zA-Z0-9]/g, '-') : '';

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/" />
        <h1>Freizeit</h1>
      </div>
      <button
        className={`freizeitbutton bereich_button ${bereichClass}`}
        onClick={() => navigate('/freizeitangebote')}
      >
        Freizeitangebote
      </button>
      <button
        className={`freizeitbutton bereich_button ${bereichClass}`}
        onClick={() => navigate('/logistik/inventar')}
      >
        Inventar
      </button>
    </div>
  );
}

export default Freizeit;
